import { getMediaQuerySize, getMaxMediaQuerySize } from 'src/utils'

export default theme => {
  const mediaQuery = getMediaQuerySize()
  const maxMediaQuery = getMaxMediaQuerySize()

  return {
    wrapper: {
      backgroundColor: theme.backgroundColor
    },
    wrapperWithoutFooter: {
      backgroundColor: theme.backgroundColor,
      minHeight: theme.minHeight
    },
    topFix: {
      position: 'fixed',
      zIndex: 1,
      padding: '0 30px',
      height: 147.75,
      [mediaQuery]: {
        height: 83.75
      }
    },
    paddingTop: {
      [mediaQuery]: {
        paddingTop: 83.75
      },
      [maxMediaQuery]: {
        height: 147.75
      }
    },
    listProd: {
      width: '25%'
    },
    noPadding: {
      padding: 0
    },
    cities: {
      margin: 15,
      backgroundColor: 'white',
      padding: 15,
      '& > h1': {
        marginTop: 0,
        textTransform: 'uppercase'
      }
    },
    titreRecherche: {
      textAlign: 'center',
      fontWeight: theme.regular,
      fontSize: theme.tailleGrandTexte,
      color: 'white'
    },
    loading: {
      textAlign: 'center',
      color: 'white',
      fontWeight: theme.bold,
      fontSize: theme.tailleMoyenTexte
    },
    breadcrumb: {
      marginLeft: 15
    }
  }
}
